import { formatPrice } from 'utils/helpers';
import { RefundListResponse } from 'store/api/refund/types';

export const getTotals = (data?: RefundListResponse['totals']) => [
  { title: 'Total Sales', value: formatPrice(data?.totalSales) },
  { title: 'Refunded Amount', value: formatPrice(data?.totalRefundedAmount) },
  { title: 'Items Quantity', value: data?.totalQuantity },
];
